<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Goods/mrchantIndex.html')">商品管理</div></el-breadcrumb-item>
            <el-breadcrumb-item>店铺-商品</el-breadcrumb-item>
        </el-breadcrumb>

        <el-form :inline="true" :model="item" class="search">
            <el-form-item label="商品名称">
                <el-input v-model="item.name" placeholder="请输入商品名称"
                          size="small"></el-input>
            </el-form-item>
            <el-form-item label="商品分类">
                <el-cascader v-model="item.product_category_id"
                     placeholder="请选择"
                     :options="optionsProduct"
                     :props="filterProps"
                     clearable></el-cascader>
            </el-form-item>
            <el-form-item label="所属店铺">
                <el-select v-model="item.store_id" clearable placeholder="所属店铺" size="small">
                    <el-option
                            v-for="item in options_store"
                            :key="item.value"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" size="medium">查询</el-button>
<!--                <el-button type="primary" @click="excelOut" size="medium">批量导入</el-button>-->
                <el-button type="primary" @click="excelOut" size="medium">批量导出</el-button>
            </el-form-item>
        </el-form>
        <div class="btns">
            <el-button type="primary" size="small" @click="upper" v-auth="['admin/goods/upper']">上架</el-button>
            <el-button type="danger" size="small" @click="downer" v-auth="['admin/goods/downer']">下架</el-button>
        </div>
        <!--		:data="list"数据-->
        <el-table :data="list" border @selection-change="handleSelectionChange">
            <!--			这里 prop scope传值-->
            <el-table-column type="selection" align="center"></el-table-column>
			<!-- <el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column> -->
			<el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>

			<el-table-column prop="name" label="名称"></el-table-column>
			<el-table-column label="商品图片">
				<!--				商品的组件和插槽-->
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;">
						<img :src="scope.row.product_pic_main" height="30" style="display: flex; margin-right: 5px;" />
					</div>
				</template>
			</el-table-column>
            <el-table-column prop="productcategory" label="商品分类">
                <template slot-scope="scope" v-if="scope.row.productcategory">
                    {{scope.row.productcategory.name}}
                </template>
            </el-table-column>
            <el-table-column label="浏览量">
                <template slot-scope="scope">
                    {{scope.row.view_num}}
                </template>
            </el-table-column>
            <el-table-column prop="store" label="供应商">
                <template slot-scope="scope" v-if="scope.row.store">
                    {{scope.row.store.name}}
                </template>
            </el-table-column>
			<el-table-column label="状态" align="center">
				<!--			价格模板插槽	-->
				<template slot-scope="scope">
					<el-tag size="small" type="success" v-if="scope.row.is_marketable">
						已上架
					</el-tag>
					<el-tag size="small" type="danger" v-else>
						已下架
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="created_date" label="添加时间" align="center"></el-table-column>
			<el-table-column prop="last_modified_date" label="更新时间" align="center"></el-table-column>

            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <!--					传ID过去修改-->
                    <el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['admin/product/detail']">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--		页码-->
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :current-page.sync="pageNum"
        	:page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
        	layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
    export default {
        name: 'Menu',
        data() {
            return {
                // 商品数据
                list: [],
                isLoad: false,
				pageNum: 0,
                pageSize: 20,
                total: 0,
                page: 1,
                thumb: [],
                // 查询
                item: {},
                options_store: [],
                optionsProduct: [],
                filterProps: {
                    value: 'id',
                    label: 'name',
                    emitPath: false,
                    checkStrictly: true
                },
            }
        },
        created() {
			this.item = {
                page: this.page,
                limit: this.pageSize,
                authStatus: 1
            },
            this.getData()
            this.loadList()
        },
        methods: {
			gotopage(url){
				console.log(url);
				var link =  this.$router.resolve({
				    path: url,
					query: {
						page: this.item.page
					}
				});
				window.open(link.href, '_blank')
			},
            getData() {
                this.axios.post('/admin/business.store/list', {
                }).then(res => {
					this.options_store = res.data.list;
                    return this.axios.get('/admin/data/getCategoryTreeAdmin', {
                    })
                }).then(res => {
                    this.optionsProduct = res.data.list
                })
            },
            // 获取数据
            loadList() {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                //	将页码传到/Goods/index
                this.axios.post('/admin/product/listForStorePass',this.item)
                .then(res => {
                    this.isLoad = false
                    // 后端返回的商品数据列表
                    this.list = res.data.list.data
                    this.total = res.data.list.total
                })
                .catch(() => {
                    this.isLoad = false
                })
            },

            // 带着商品ID跳转
            edit(id) {
                this.$router.push({
                    path: '/Goods/edit.html',
                    query: {
                        id: id
                    }
                });
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            upper() {
                let id = []
                for (let key in this.multipleSelection) {
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }
                if (id.length == 0) {
                    this.$message.error({
                        message: '请选择商品',
                        showClose: false
                    });
                    return false;
                }
                if (this.isLoad) {
                    return false;
                }
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/product/upper', {
                    data: {id: id, in_store: 1}
                }).then(() => {
                    this.isLoad = false
                    this.$message.success({
                        message: '上架成功',
                        showClose: false
                    });
                    this.loadList()
                })
                    .catch(() => {
                        this.isLoad = false
                    })
            },
            downer() {
                let id = []
                for (let key in this.multipleSelection) {
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }
                if (id.length == 0) {
                    this.$message.error({
                        message: '请选择商品',
                        showClose: false
                    });
                    return false;
                }

                if (this.isLoad) {
                    return false;
                }

                this.isLoad = !this.isLoad
                this.axios.delete('/admin/product/downer', {
                    data: {id: id, in_store: 1}
                }).then(() => {
                    this.isLoad = false
                    this.$message.success({
                        message: '下架成功',
                        showClose: false
                    });
                    this.loadList()
                })
                .catch(() => {
                    this.isLoad = false
                })
            },
            delAll() {
                let id = []
                for (let key in this.multipleSelection) {
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }
                if (id.length == 0) {
                    this.$message.error({
                        message: '请选择商品',
                        showClose: false
                    });
                    return false;
                }
                if (this.isLoad) {
                    return false;
                }
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/product/delete', {
                    data: {
                        id: id,
                        in_store: 1
                    }
                }).then(() => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '删除成功',
                        showClose: false
                    });
                    this.loadList()
                })
                .catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            //sizeReload 共多少条为一页
            sizeReload(val) {
               this.pageSize = val
               this.item = {
               		page: this.page,
               		limit: this.pageSize,
               		authStatus: 1
               },
               this.getData()
               this.loadList()
            },
            // 前往第几页
            pageReload(val) {
                this.item.page = val
                this.loadList()
            },
            // 搜索查询
            submit() {
				this.pageNum = 1
                this.item.page = 1
                this.loadList()
            },
            // 导出
            excelOut() {
                if (this.isLoad) {
                    return false
                }

                this.isLoad = !this.isLoad
                setTimeout(function () {
                    this.isLoad = false
                }.bind(this), 100000);
                this.axios.post('/admin/product/listForStorePassExport', this.item)
                    .then(res => {
                        this.isLoad = false
                        if (res.code == 1) {
                            import('@/vendor/Export2Excel.js').then(excel => {
                                var expCellName = res.data.expCellName
                                var tHeader = []
                                var filterVal = []
                                for (var i in expCellName) {
                                    tHeader.push(expCellName[i])
                                    filterVal.push(i)
                                }
                                const expTableData = res.data.expTableData
                                const data = this.formatJson(filterVal, expTableData)
                                var d = new Date()
                                var year = d.getFullYear()
                                var month = d.getMonth()
                                var date = d.getDate()
                                var hour = d.getHours()
                                var minute = d.getMinutes()
                                var second = d.getSeconds()
                                month = month < 10 ? '0' + month : month
                                date = date < 10 ? '0' + date : date
                                hour = hour < 10 ? '0' + hour : hour
                                minute = minute < 10 ? '0' + minute : minute
                                second = second < 10 ? '0' + second : second
                                excel.export_json_to_excel({
                                    header: tHeader,
                                    data,
                                    filename: '店铺商品导出_' + year + '' + month + '' + date + '' + hour + '' + minute + '' + second,
                                    autoWidth: this.autoWidth,
                                    bookType: this.bookType
                                })
                            })
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 3 * 1000
                            })
                        }
                    })
            },
            formatJson (filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                    return v[j]
                }))
            },
        }
    }
</script>
<style scoped>
</style>
